import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import UserForm from './UserForm';
import './UserList.css';

const UserList = () => {
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    const fetchUsers = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await api.get('/users/');
            console.log('Полный ответ от API:', response);
            if (response) {
                setUsers(response);
            } else {
                console.error('Данные из API отсутствуют или являются null.');
            }
        } catch (error) {
            setError(error.message || 'Произошла неизвестная ошибка');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const handleDelete = async (id) => {
        if (!window.confirm('Вы уверены, что хотите удалить пользователя?')) {
            return;
        }
        setIsLoading(true);
        setError(null);
        try {
            await api.delete(`/users/${id}`);
            fetchUsers();
        } catch (error) {
            setError(error.message || 'Произошла неизвестная ошибка');
        } finally {
            setIsLoading(false);
        }
    };

    const handleEdit = (user) => {
        setSelectedUser(user);
        setModalIsOpen(true);
    };

    const handleAddUser = () => {
        setSelectedUser(null);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setSelectedUser(null);
    };

    const handleUserUpdated = () => {
        fetchUsers();
        closeModal();
    };

    // Встроенные компоненты Loading и ErrorMessage
    const LoadingIndicator = () => (
        <div className="loading">
            <p>Загрузка...</p>
        </div>
    );

    const ErrorMessage = ({ message }) => (
        <div className="error-message">
            <p>{message}</p>
        </div>
    );

    // Модальное окно
    const Modal = ({ isOpen, onClose, children }) => {
        if (!isOpen) return null;

        return (
            <div className="modal-overlay">
                <div className="modal-content2">
                    <button className="modal-close-button" onClick={onClose}>×</button>
                    {children}
                </div>
            </div>
        );
    };

    return (
        <div className="users-page-container">
            <div className="users-main-block">
                <h2>Пользователи</h2>
                <button onClick={handleAddUser} className="users-addButton">Добавить пользователя</button>
                {isLoading && <LoadingIndicator />}
                {error && <ErrorMessage message={error} />}
                
                {/* Модальное окно */}
                <Modal isOpen={modalIsOpen} onClose={closeModal}>
                    <UserForm
                        user={selectedUser}
                        onUserUpdated={handleUserUpdated}
                        onClose={closeModal}
                    />
                </Modal>

                <div className="users-cardsContainer">
                    {users && users.map((user) => (
                        <div key={user.id} className="users-card">
                            <div className="users-cardHeader">
                                <h3>{user.firstname} {user.lastname}</h3>
                                <span className="users-username">{user.username}</span>
                            </div>
                            <div className="users-cardBody">
                                <p>Email: {user.email ? user.email : 'не указан'}</p>
                            </div>
                            <div className="users-cardBody">
                                <p>Имя: {user.firstName ? user.firstName : 'не указана'}</p>
                            </div>
                            <div className="users-cardBody">
                                <p>Фамилия: {user.lastName ? user.lastName : 'не указана'}</p>
                            </div>
                            <div className="users-cardFooter">
                                <button onClick={() => handleEdit(user)} className="users-editButton">Редактировать</button>
                                <button onClick={() => handleDelete(user.id)} className="users-deleteButton">Удалить</button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default UserList;
